module.exports = __webpack_public_path__ + "static/img/010.7ce71d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/010.jpg
// module id = JL1i
// module chunks = 1